import { useContext, useEffect, useState } from "react";
import { IconAtom2 } from "../atoms/iconAtom"
import { AILeadModal } from "../components/aiLeadModal"
import { HorizontalLayout, VerticalLayout } from "../components/layout"
import { InputForm } from "../atoms/input";
import { CompanyComp } from "../components/companyComp";
import { IconButton, StandardButton } from "../atoms/buttons";
import { fetchAPI, getAPI, postAPI } from "../api/api";
import { AddLeadModal, LeadComp } from "../components/leadComp";
import { PageContext, ToastContext } from "../App";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "../components/modal";

export const LeadsScreen = () => {

    const [activeScreen, setActiveScreen] = useState(0);
    const [activeLeadModal, setActiveLeadModal] = useState(false);
    const [activeModal, setActiveModal] = useState(false);
    const lead_or_org = (activeScreen === 1)
    const [companyData, setCompanyData] = useState([])
    const [leadData, setLeadData] = useState([])
    const [orgModal, setOrgModal] = useState(false)
    useEffect(() => {
        loadCompanyData()
    }, [])

    const loadCompanyData = async () => {
        const query = "api/leads/companies"
        const companyData = await getAPI(query)
        console.log("company data", companyData)
        setCompanyData(companyData.data)
    }

    const loadLeads = async () => {
        const query = "api/leads/leads"
        const companyData = await getAPI(query)
        setLeadData(companyData.data)
    }

    const handleFinish = () => {
        loadCompanyData()
        setActiveLeadModal(false)
        setActiveModal(false)
    }
    const handleSwitch = async (id) => {
        setActiveScreen(id)
        if (id) return await loadLeads()
        loadCompanyData()
    }
    const handleOpenModal = () => {
       if (activeScreen === 0) {
            setOrgModal(true)
       }else{
            setActiveLeadModal(true)
       }
        
    }
    return (
        <VerticalLayout
            className="body-screen standard-padding"
            style={{ boxSizing: "border-box", gap: "1rem" }}
        >
            <HorizontalLayout className="header-switcher-container">
                <HeaderSwitcher
                    switchNow={handleSwitch}
                    options={[{ label: "Organisaties", id: 0 }, { label: "Leads", id: 1 }]}
                    active={activeScreen}
                />
                <HorizontalLayout className="lead-action-row">
                    <LeadActionRow newLeadModal={handleOpenModal} activateAImodal={() => setActiveModal(1)} />
                    <SearchInput />
                </HorizontalLayout>
                
            </HorizontalLayout>
            {!lead_or_org ? <CompanyComp companyData={companyData} loadLeadsData={loadCompanyData} /> : <LeadComp reload={loadLeads} loadLeadsData={loadLeads} leadData={leadData} />}
            <AILeadModal mode={activeScreen} finished={handleFinish} visible={activeModal} dismiss={() => setActiveModal(0)} />
            <AddOrgModal
                visible={orgModal}
                dismiss={() => setOrgModal(false)}
                load={loadCompanyData}
            />
            <AddLeadModal
                loadLeads={loadLeads}
                modalVisible={activeLeadModal}
                setModalVisible={() => setActiveLeadModal(!activeLeadModal)}
            />
        </VerticalLayout>
    )
}

const AddOrgModal = ({ visible, load, dismiss }) => {
    
    const toastContext = useContext(ToastContext);
    const [createModalData, setCreateModalData] = useState({
        name: "",
        website_url: "",
        linkedin_url: "",
        description: "",
        category: null,
    });
    const updateCreatedUser = (value, field) => {
        setCreateModalData(prev => ({
            ...prev,
            [field]: value
        }));
    };
    const addLead = async () => {
        if (!createModalData.name || !createModalData.category) {
            return toastContext.showToast("Bedrijfsnaam en categorie zijn verplicht.", "error");
        }
        const query = "api/leads/company/add";
        const body = {
            ...createModalData
        }
        const res = await postAPI(query, body);
        console.log("add lead response", res)
        if (res.status === "ok") {
            dismiss();
            load();
            toastContext.showToast("Organisatie succesvol toegevoegd!", "success");
        }
        if (res.message === "Duplicated data") {
            toastContext.showToast("Er bestaat al een organisatie met deze naam, probeer het opnieuw met een andere naam.", "error");
        }
    }
    const inputFields = [
        { key: "name", title: "Bedrijfsnaam*", placeholder: "Organisatie BV" },
        { key: "website_url", title: "Website URL", placeholder: "Optioneel" },
        { key: "linkedin_url", title: "LinkedIn URL", placeholder: "Optioneel" },
        { key: "description", title: "Beschrijving", placeholder: "Optioneel" },
        { key: "category", title: "Categorie*", placeholder: "Bouw, Technologie, Gezondheidszorg..." },
    ];
    return (
        <Modal height={null} visible={visible} dismiss={dismiss}>
            <ModalTitle title={"Nieuwe organisatie toevoegen"} hasXmark={true} dismissable={dismiss}/>
            <ModalBody>
                {inputFields.slice(0,1).map(field => (
                    <InputForm
                        key={field.key}
                        value={createModalData[field.key]}
                        typeInput={(v) => updateCreatedUser(v, field.key)}
                        title={field.title}
                        placeholder={field.placeholder}
                    />
                ))}
                  <HorizontalLayout style={{ gap: "1rem" }}>
                    {inputFields.slice(1, 3).map(field => (
                        <InputForm
                            key={field.key}
                            value={createModalData[field.key]}
                            typeInput={(v) => updateCreatedUser(v, field.key)}
                            title={field.title}
                            placeholder={field.placeholder}
                        />
                    ))}
                </HorizontalLayout>

                {inputFields.slice(3).map(field => (
                    <InputForm
                        key={field.key}
                        value={createModalData[field.key]}
                        typeInput={(v) => updateCreatedUser(v, field.key)}
                        title={field.title}
                        placeholder={field.placeholder}
                    />
                ))}
            </ModalBody>
            <ModalFooter>
                <StandardButton title={"Annuleren"} backgroundColor="grey-200" textColor="grey-800" onClick={dismiss} />
                <StandardButton title={"Toevoegen"} onClick={addLead} />
            </ModalFooter>
        </Modal>
    )
}

const SearchInput = () => {
    return (
        <InputForm
            className="standard-input standard-border standard-rounded"
            style={{ maxWidth: "200px", margin: 0, marginLeft: "0.5rem" }}
            type="text"
            placeholder="Bedrijf zoeken..."
        />
    )
}

const HeaderSwitcher = ({ options, active, switchNow }) => {
    return (
        <HorizontalLayout className={"header-switcher"} style={{ gap: "1px", width: 'unset', borderRadius: "calc(.5rem * var(--br-scale))" }}>
            {options.map((option, index) => (
                <div onClick={() => switchNow(option.id)} key={index} className={`header-switcher-option ${(active === index) && 'header-switcher-option-active'}`}>
                    <p className="large-text bold-medium standard-text-color-dark" style={{ backgroundColor: "unset" }}>{option.label}</p>
                </div>
            ))}
        </HorizontalLayout>
    )
}

const LeadActionRow = ({ activateAImodal, newLeadModal }) => {
    const lead_style = {
        display: "flex",
        width: "2.5rem",
        height: "2.3rem",
        borderRadius: "calc(.5rem * var(--br-scale))", padding: "0", justifyContent: "center", alignItems: "center", backgroundColor: "var(--primary-500)", color: "white"
    }
    return (
        <HorizontalLayout className="action-row" style={{ gap: "0.5rem", width: "unset", marginLeft: "auto" }}>
            <IconButton
                onClick={newLeadModal}
                style={lead_style}
                iconButton={true}
                label="Nieuwe lead"
                color="primary-600"
                icon2="plus"
            />
            <IconButton
                onClick={activateAImodal}
                style={lead_style}
                label="Importeren"
                color="grey-600"
                icon2="robot"
            />
        </HorizontalLayout>
    )
}


